module.exports = __webpack_public_path__ + "img/ic_price_white_eur.707c5e2d.svg";